declare const jQuery: any;
const $ = jQuery;

// Change the quote slider to fade instead of slide
$(".challenges-slider").on("change", function (event, data) {
	$(this).find(".text-image-slider-item").fadeTo(0, 0).eq(data.itemIndex).fadeTo(400, 1);
});

const $btn = $(`.load-more [data-load-more-button]`);
if ($btn.length > 0) {
	const $select = $(`.challenges-filter select[name="challenge-type"], .partners-filter select[name="partner-type"]`);
	const updateTypeId = () => {
		const typeId: number = parseInt($select.val(), 10) || null;
		$btn.trigger("updatesetting", {
			termId: typeId
		}).trigger("reset");

		// poll the body classes to check when the AJAX call has completed
		const loadMoreBusyInterval = window.setInterval( () => {
			const body = document.getElementsByTagName('body')[0];
			if( ! body.classList.contains('load-more-busy') ) {
				window.clearInterval(loadMoreBusyInterval);
				initPopupLinks();
			}
		}, 500);
	};
	$select.on("change", updateTypeId);
	if ($select.val())
	{
		updateTypeId();
	}
}

const initPopupLinks = function() {
	$('a[data-popup-link').on('click', function (e) {
		e.preventDefault();
		const popupId = $(this).data('popup-link');
		window["iw"].popups.openPopupById(popupId);
	});
}
initPopupLinks();
